export const API = {
  // USER_LOGIN: '/user/login',
  USER_LOGIN: '/API/auth/login',
  USER_LOGOUT: '/API/auth/logout',
  USER_AUTH: '/API/login/session',
  ASSET: '/API/asset/search',
  ASSET_DOWNLOAD: '/API/asset/download',
  ASSET_LOWRES_DOWNLOAD: '/API/download/lowres',
  ASSET_DOWNLOAD_CHECK: '/API/asset/download/check',
  STORAGE: '/API/storage',
  CATEGORY: '/API/category',
  SCRIPT: '/API/script',
  WKBL_SCRIPT: '/API/wkbl/script',
  WKBL_QUARTER: '/API/wkbl/quarter',
  WKBL_VIDEO_SEARCH: '/API/wkbl/video/search',
  LIBRARY: '/API/library',
  LIBRARY_AWS_DOWNLOAD: '/API/download/video/library',
  DOWNLOAD_URL_LOWRES: '/API/download/url/lowres',
  DOWNLOAD_URL_PARTIAL: '/API/download/url/library',
  CODE: '/API/code',
  PREFERENCE: '/API/preference',
  PREFERENCE_BY_BANNER: '/API/preference/banner',
  TEAM: '/API/team',
  CONFIG: '/API/config',
  STATISTICS: '/API/statistics/general',
  STATISTICS_ASSET: '/API/statistics/general/asset',
  STATISTICS_STORAGE: '/API/statistics/general/storage',
  STATISTICS_EXPORT: '/API/statistics/export',
  STATISTICS_LOG: '/API/statistics/log',
  TEAM_LOGO: '/API/team/logo/image',
  PERSON_IMAGE: '/API/person/image',
  AWS: '/API/aws/check/object'
};
